import React from 'react';
import { Box, Button, Typography, Paper, Container } from '@mui/material';
import ReactPlayer from 'react-player';
import '../../../../styles/customScrollbar.css';

const ContentCreatorStep = ({ step, ongetStarted, totalSteps, videoUrl, textContent, textContent2, textContent3, onButtonClick,
    title, titleContent
}: any) => {
    return (
        <>
            <Paper sx={styles.paper}>
                <Box sx={styles.header}>
                    <Typography sx={styles.title}>
                        {title}
                    </Typography>
                    <Box display={"flex"} gap={4} >
                        <Typography sx={styles.step}>
                            {titleContent}
                        </Typography>
                        <Typography variant="subtitle2" sx={styles.progress}>
                            {step}/{totalSteps}
                        </Typography>
                    </Box>

                </Box>

                <Box sx={styles.videoContainer}>
                    <ReactPlayer
                        url={videoUrl}
                        width={"100%"}
                        style={{ borderRadius: '6.05px', overflow: "hidden" }}

                        controls
                        muted
                    />
                </Box>

                <Box className="custom-scrollbar" sx={{
                    maxHeight: { xs: 'auto', md: '192px' }, overflowY: { xs: 'hidden', md: 'scroll' }, padding: { xs: '8px', md: '16px' },
                    width: { xs: '357px', md: '823px' },

                }}>
                    <Box
                        sx={styles.content}
                        display={"flex"} flexDirection={"column"}
                        gap={2}>

                        <Typography variant="body1" sx={styles.textContent}>
                            {textContent}
                        </Typography>
                        <Typography variant="body1" sx={styles.textContent}>
                            {textContent2}
                        </Typography>
                        <Typography variant="body1" sx={styles.textContent}>
                            {textContent3}
                        </Typography>
                    </Box>


                </Box>

                <Box sx={styles.buttonContainer}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => { onButtonClick(); ongetStarted() }}
                        sx={styles.button}
                    >
                        Get Started
                    </Button>
                </Box>
            </Paper>
        </>
    );
};

const styles = {

    paper: {
        paddingBottom: 3,
        // borderRadius: 3,
        // padding: "20px",
        background: "#F8F8F8",
        borderRadius: "10px",
        border: "1px solid #A9A9A9"
    },
    header: {
        padding: 3,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '2px solid #e0e0e0',
        paddingBottom: 2,
        marginBottom: 2,
    },
    title: {
        fontWeight: 700,
        fontSize: 18,
        color: '#797979',
    },
    step: {
        fontWeight: 500,
        fontSize: 18,
        color: '#797979',
    },
    progress: {
        fontWeight: 500,
        fontSize: 18,
        color: '#797979',
    },
    videoContainer: {
        padding: { xs: 1, md: 3 },
        position: 'relative',
        // height: "385.91px",
        width: { xs: "345px", md: "793px" },
        borderRadius: "40px",
        marginBottom: 2,
    },
    reactPlayer: {
        borderRadius: "40px",
    },
    content: {
        marginBottom: 2,
        padding: 1,
        width: { xs: "357px", md: "793px" },

    },
    textContent: {
        fontSize: 17,
        fontWeight: 400,
        lineHeight: "24px",
        color: '#000000',
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
    },
    button: {

        backgroundColor: '#233F91',
        width: '142px',
        marginTop: '18px',
        height: "57px",
        borderRadius: "15px",
        Padding: "8px, 25px, 8px, 25px",
        fontSize: "18px",
        fontWeight: 700,
        color: '#fff',
        '&:hover': {
            backgroundColor: '#1e327b',
        },
    },
};

export default ContentCreatorStep;
